// src/App.tsx
import './App.css';
import './i18n';
import AppRouter from './router/AppRouter';
import { GridBackgroundLayout } from '@components/layout/GridBackgroundLayout';
import { AppToastContainer } from '@components/ui/AppToastContainer/AppToastContainer';
import { AppOfflineOverlay } from '@components/ui/AppOfflineOverlay/AppOfflineOverlay';
import { AnalyticsConsentControls } from '@components/analytics/AnalyticsConsentControls';
import { AnalyticsConsentProvider } from '@context/AnalyticsConsentContext';

function App() {
  return (
    <AnalyticsConsentProvider>
      <GridBackgroundLayout disableOnMobile>
        <AppRouter />
      </GridBackgroundLayout>
      <AnalyticsConsentControls />
      <AppToastContainer />
      <AppOfflineOverlay />
    </AnalyticsConsentProvider>
  );
}

export default App;
